// 文章列表页面

<template>
  <div class="article-container">
    <div>
      <template v-if="articles.length">
        <!-- 文章列表：时间、标题、预览，每页10条 -->
        <div class="art-items" v-for="item of articles" :key="item.id">
          <!-- 左侧时间区域 -->
          <div class="left">
            <p style="font-size: 34px; line-height: 40px">
              {{ dateFormate(item.publishDate)[1] }}
            </p>
            <p style="line-height: 24px">
              {{ dateFormate(item.publishDate)[0] }}
            </p>
          </div>
          <!-- 右侧标题和内容-->
          <div class="right" @click="toDetail(item)">
            <!-- 不区分是否为下载，下载的去文章附件里下载 -->
            <p class="title" v-reds="$route.query.searchText">
              {{ item.title }}
            </p>
            <v-clamp
              autoresize
              :max-lines="3"
              class="detail"
              v-reds="$route.query.searchText"
              :clampTxt="item.columnType == '1'?'':item.contentForSearch"
              
            />
          </div>
        </div>
        <!-- 分页组件 -->
        <div class="art-pages">
          <el-pagination
            background
            :current-page.sync="pages.current"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pages.total"
            :page-size.sync="pages.size"
            @size-change="getTableData"
            @current-change="getTableData"
          >
          </el-pagination>
        </div>
      </template>
      <!-- 无内容时，加点提示 -->
      <template v-else>
        <none-icon />
        <p class="none-msg">未搜索到内容</p>
      </template>
    </div>
    <showPDF ref="showPDF" />
  </div>
</template>

<script>
import axios from "axios";
import showPDF from "./showPDF.vue";
// import VClamp from 'vue-clamp'
export default {
  name: 'articleList',
  name: "HomePage",
  components: {
    showPDF,
  },
  data() {
    return {
      productCenterType:this.$route.query.productCenterType,
      articles: [], // 文章列表
      pages: {
        total: 0,
        current: 1,
        size: 10
      },
     
    }
  },

  created() {
    this.getTableData()
  },
  watch: {
    $route() {
      this.pages.total = 0
      this.pages.current = 1
      this.pages.size = 10
      this.getTableData()
    }
  },
  methods: {
     asyncTo(promise) {
      return promise.then((data) => [null, data]).catch((err) => [err]);
    },
    async handleResourceInfo(item) {
      console.log(item,'-----')
      //1 资源类 打开新页面
      if (item.columnType == "1") {
        const [error ,{result} ]  = await this.asyncTo(this.$api.selectDescInfoById({id: item.id}))  
        if(error){
          return
        }
        console.log(result.content)
       const fileSplit =  result.content.match(/fileName=([\S\s]*\.(\S*))/)
        console.log(fileSplit[2] == "pdf")
        if (fileSplit[2] == "pdf") {
          console.log(fileSplit[2] )
          this.showPDF(result.content, fileSplit[1]);
          return false
        } else {
          window.open(result.content);
        }
        return false;
        
      } else {
        return true;
      }
    },
    //查看pdf
    showPDF(path, name) {
      console.log(path, name)
      let reg = /http:\/\/.*\.[0-9]{1,4}(:[\w]+)?/g

      path = path.replace(reg,process.env.VUE_APP_BASE)

      axios.get(path, { responseType: "blob" }).then(({ data }) => {
        console.log(data);
        let file = {};
        const blob = new Blob([data]);
        const url = window.URL.createObjectURL(blob);
        console.log(url);
        file.fileUrl = url;
        file.fileType = "pdf";
        file.name = name;
        this.$refs.showPDF.init(file);
      });
    },
    // 文章的创建日期格式化
    dateFormate(d) {
      return [d.slice(0, 4), d.slice(5, 10)]
    },
    toDetail(item) {
      console.log(item)
      if (item.columnType == "1") {
        this.handleResourceInfo(item)
        return
      }else{
        this.$router.push({
          path: '/detail',
          query: { id: item.id, label: this.$route.query.label }
        })
      }

      
    },
    // 根据指定的值，进行搜索
    getSearchText() {
    
      console.log('获取查询的内容：', this.$route.query.searchText)
      const data = {
        entity: {
          content: this.$route.query.searchText,
          pageNum: this.pages.current,
          pageSize: this.pages.size
        },
        pageNum: this.pages.current,
        pageSize: this.pages.size
      }
      this.$api.search(data).then((r) => {
        console.log('站内搜索：', r)
        this.articles = r.result.list
        this.pages.total = r.result.total
      })
    },
    // 根据栏目id，获取列表
    getTabId() {
      console.log('根据id，获取列表：', (this.$route.query.label).match(/(\S*)\s\-\s\S*/))
      const data = {
        entity: {
          column:this.productCenterType>0? (this.$route.query.label).match(/(\S*)\s\-\s\S*/)[1]:this.$route.query.label,
          pageNum: this.pages.current,
          pageSize: this.pages.size
        },
        pageNum: this.pages.current,
        pageSize: this.pages.size
      }
      this.$api.columnList(data).then((r) => {
        if(this.productCenterType>0){
          this.articles = r.result.list
          this.articles =  this.articles.filter((item)=>{
            return item.productCenterType == this.productCenterType
          })
        }else{
          this.articles = r.result.list
          this.pages.total = r.result.total
        }
      })
    },
    // 获取列表数据
    getTableData() {
      // 如果进来时候，传入了searchText，就是搜索列表
      // 否则，传入了栏目的id,tabid，就是拉取栏目列表
      this.$route.query.searchText ? this.getSearchText() : this.getTabId()
    }
  }
}
</script>

<style lang="less" scoped>
.article-container {
  padding-top: 20px;
  min-height: 400px;
  & > div {
    // width: 1270px;
    width: 1000px;
    margin: auto;
    box-sizing: border-box;
    padding: 20px 30px 0 30px;
  }
  .art-items {
    display: flex;
    // height: 40px;
    margin-bottom: 20px;
    .left {
      width: 120px;
      color: #999999;
      font-size: 18px;
      text-align: right;
      margin-right: 30px;
    }
    .right {
      // width: 600px;
      width: 0;
      flex-grow: 1;
      padding-bottom: 20px;
      border-bottom: 1px dotted #e0d7d7;
      cursor: pointer;
      .title {
        font-size: 14px;
        font-weight: bolder;
        padding-bottom: 10px;
      }
      .detail {
        color: #999999;
        font-size: 12px;
        // line-height: 18px;
      }
    }
  }
  .art-pages {
    width: 600px;
    margin: auto;
    padding: 20px 0;
  }
  // 无内容时的提示
  .none-msg {
    font-size: 14px;
    font-weight: bolder;
    text-align: center;
    width: 100%;
    color: #999999;
  }
}
</style>
